<script>
import SplashScreen from '@components/SplashScreen'
import CardPoliticaDePrivacidade from './components/CardPoliticaDePrivacidade.vue'

export default {
  name: 'App',
  components: {
    SplashScreen,
    CardPoliticaDePrivacidade
  }
}
</script>
<template>
  <div id="app">
    <router-view v-if="wl.loaded" />
    <splash-screen :visible="!wl.loaded" />
    <card-politica-de-privacidade />
  </div>
</template>

<style>
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
html, body {
  margin: 0;
  background-color: var(--background);
  color: var(--on-background);
  box-sizing: border-box;
}
html {
    overflow-x: hidden;
  overflow-y: scroll;
}
</style>
